import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { SubscriptionPlansConfig } from "../config/subscriptionPlansConfig";

/**
 * Creates a free subscription for a new user on signup.
 * Uses the correct free plan based on user type (lawyer, client, law student).
 *
 * @param {string} userId - The Firebase Auth UID of the user
 * @param {string} userType - 'lawyer', 'client', or 'lawStudent' (defaults to 'lawyer')
 * @returns {Promise<{created: boolean, durationDays: number}>} `created` is true only
 *   when a new free subscription was written (false if one already existed); `durationDays`
 *   is the length of the free plan that was granted (0 when nothing was created).
 */
export async function createFreeSubscription(userId, userType = 'lawyer') {
  if (!userId) return { created: false, durationDays: 0 };

  try {
    const subscriptionRef = doc(db, "subscriptions", userId);
    const subscriptionDoc = await getDoc(subscriptionRef);

    // Don't overwrite if subscription already exists
    if (subscriptionDoc.exists()) {
      console.log("Subscription already exists for user:", userId);
      return { created: false, durationDays: 0 };
    }

    const freePlan = SubscriptionPlansConfig.getFreePlan(userType);
    const durationDays = freePlan?.durationDays || 15;

    const startDate = new Date();
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + durationDays);

    await setDoc(subscriptionRef, {
      transactions: [
        {
          userCateogry: userType || "",
          type: "free",
          category: freePlan?.category || "free",
          "start-time": startDate,
          "end-time": endDate,
        },
      ],
    });

    console.log(`Free ${durationDays}-day subscription created for user:`, userId, `(${userType})`);
    return { created: true, durationDays };
  } catch (error) {
    console.error("Error creating free subscription:", error);
    return { created: false, durationDays: 0 };
  }
}
